import { Euro } from 'lucide-react';
import { ReunionTransaction } from '../../../hooks/useReunionMensuelleData';
import { PeriodBucket, getPeriodKeyForDate, buildPeriodColumnAverages } from '../../../utils/reunionMensuelle';
import { Scope, ScopeColumn, getColumnForTransaction } from './ScopeSelector';
import TrendChartCard from './TrendChartCard';

interface HonorairesTabProps {
  transactions: ReunionTransaction[];
  periods: PeriodBucket[];
  columns: ScopeColumn[];
  scope: Scope;
}

export default function HonorairesTab({ transactions, periods, columns, scope }: HonorairesTabProps) {
  const columnKeys = columns.map(c => c.key);
  const getPeriodKey = (tx: ReunionTransaction) => getPeriodKeyForDate(tx.compromise_date, periods);
  const getColumnKey = (tx: ReunionTransaction) => getColumnForTransaction(tx, scope);

  const averages = buildPeriodColumnAverages(
    transactions,
    periods,
    columnKeys,
    getPeriodKey,
    getColumnKey,
    tx => tx.fees_without_tax
  );

  const formatEuros = (v: number) => Math.round(v).toLocaleString('fr-FR');

  return (
    <TrendChartCard
      icon={<Euro size={16} className="text-violet-600" />}
      iconBg="bg-violet-50"
      title="Moyenne d'honoraires HT"
      periods={periods}
      columns={columns}
      data={averages}
      valueFormatter={formatEuros}
      valueSuffix=" €"
      getTransactions={(periodKey, columnKey) =>
        transactions.filter(tx => getPeriodKey(tx) === periodKey && getColumnKey(tx) === columnKey)
      }
      infoText="Chaque vente est rangée dans le mois/trimestre de sa date de compromis. On fait la moyenne des honoraires HT (avant rétrocessions) des ventes du mois."
    />
  );
}
